module.exports = __webpack_public_path__ + "static/advanced-security-ssl-835909689bcd9466e2270c76eff823a6.svg";